import React, { useEffect, useState, useRef } from "react";
import "./TopSellerExcellence.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import { EffectCoverflow, Navigation } from "swiper/modules";
import Card from "react-bootstrap/Card";
import { TiStarFullOutline, TiStarOutline } from "react-icons/ti";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../constant";
import { toast } from "react-toastify";
import img5 from "../../images/Rectangle5.png";
import { useCartContext } from "../../Context/CartContext";
import { useWishlistContext } from "../../Context/WishlistContext";
import { FaRegStar, FaStar } from "react-icons/fa6";

function TopSellerExcellence() {
  const { productId } = useParams();
  const navigate = useNavigate();
  let stars = Array.from({ length: 5 });
  const [products, setProducts] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [wishlistItems, setWishlistItems] = useState([]);
  const { fetchCartCount } = useCartContext();
  const swiperRef = useRef(null);
  const { fetchWishlistCount } = useWishlistContext();
  const [reviews, setReviews] = useState([]);
  const [productDetails, setProductDetails] = useState([]);

  useEffect(() => {
    fetchCartItems();
    fetchWishlistItems();
    fetchProducts();
    fetchCartCount();
    fetchWishlistCount();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/customProducts/top-seller`
      );
      setProducts(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const fetchCartItems = async () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const response = await axios.post(
          `${BASE_URL}/usercart/in-cart?userId=${userId}&pageSize=10000`
        );
        setCartItems(response.data);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    }
  };

  const fetchWishlistItems = async () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const response = await axios.get(`${BASE_URL}/wishlist/get/${userId}`);
        setWishlistItems(response.data);
      } catch (error) {
        console.error("Error fetching wishlist items:", error);
      }
    }
  };

  useEffect(() => {
    const fetchProductDetails = async () => {
      const userId = localStorage.getItem("userId");
      try {
        const response = await axios.get(
          `${BASE_URL}/products/productId?userId=${userId}&id=${productId}`
        );
        setProductDetails(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };
    const fetchReviews = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/product-ratings/product/${productId}`
        );
        setReviews(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };
    fetchProductDetails();
    fetchReviews();
  }, [productId]);

  const handleAddToCart = async (productId) => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const cartResponse = await axios.post(
          `${BASE_URL}/usercart/add-product?userId=${userId}&productId=${productId}&orderQuantity=1`
        );
        await fetchCartCount();
        toast.success("Product added to cart");
        fetchCartItems();
      } catch (error) {
        console.error("Error adding product to cart:", error);
        toast.error("Something went wrong! Try again later");
      }
    } else {
      navigate("/login");
    }
  };

  const handleAddToWishlist = async (productId) => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const wishlistResponse = await fetch(
          `${BASE_URL}/wishlist/add/${userId}`,
          {
            method: "POST",
            headers: {
              contentType: "application/json",
            },
            body: productId,
          }
        );
        setWishlistItems((prevWishlist) => [...prevWishlist, { productId }]);
        fetchWishlistCount();
        console.log(productId);
        console.log(wishlistResponse.data);
        toast.success("Product added to wishlist");
        fetchWishlistItems();
      } catch (error) {
        console.error("Error adding product to wishlist:", error);
        toast.error("Something went wrong! Try again later");
      }
    } else {
      navigate("/login");
    }
  };

  const removeWishlistItem = async (productId) => {
    const userId = localStorage.getItem("userId");
    try {
      const response = await axios.delete(
        `${BASE_URL}/wishlist/delete/${userId}/${productId}`
      );
      console.log(response);
      setWishlistItems((prevWishlist) =>
        prevWishlist.filter((item) => item.productId !== productId)
      );
      await fetchWishlistCount();
      toast.error("Product removed from wishlist");
      fetchWishlistItems();
    } catch (error) {
      console.error("Error removing product from wishlist:", error);
      toast.error("Something went wrong! Try again later");
    }
  };

  const handleMouseEnter = (index) => {
    const swiper = swiperRef.current.swiper;
    swiper.slideTo(index, 600); // Slide to the center smoothly over 600ms
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        i <= Math.floor(rating) ? (
          <TiStarFullOutline key={i} className="star-icon filled" />
        ) : (
          <TiStarOutline key={i} className="star-icon" />
        )
      );
    }
    return stars;
  };

  return (
    <div className="top-seller">
      <div className="headings">
        <h1 className="fst-italic top-seller-title">Top Seller Excellence</h1>
      </div>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 110,
          modifier: 2.5,
          slideShadows: false,
        }}
        modules={[EffectCoverflow, Navigation]}
        className="swiper_container"
        initialSlide={2}
        ref={swiperRef}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        speed={800}
      >
        {products.slice(0, 5).map((product, index) => {
          const firstPhotoUrl =
            product.prodImg1
              ? product.prodImg1
              : "https://balache-kapde-media.s3.ap-south-1.amazonaws.com/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
          const isInWishlist = wishlistItems.some(
            (item) => item.productId === product.productId
          );
          return (
            <SwiperSlide
              key={product.productId}
              className="img-slide"
              onMouseEnter={() => handleMouseEnter(index)}
            >
              <Card className="card">
                <Card.Img
                  variant="top"
                  className="card-img"
                  src={firstPhotoUrl}
                  onClick={() =>
                    navigate(`/productdetails/${product.productId}`)
                  }
                />
                <Card.Body className="card-content d-flex flex-column justify-content-center">
                  <h5
                    onClick={() =>
                      navigate(`/productdetails/${product.productId}`)
                    }
                  >
                    {product.productName}
                  </h5>
                  <p
                    onClick={() =>
                      navigate(`/productdetails/${product.productId}`)
                    }
                  >
                    <span
                      style={{
                        fontSize: "16px",
                        textDecoration: "line-through",
                        color: "grey",
                      }}
                    >
                      {" "}
                      Rs.{product.productMRP}
                    </span>{" "}
                    Rs.
                    {product.productRate}
                  </p>
                  {/* <div>
                    <br />
                    <br />
                  </div> */}
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center star-container">
                      {[...Array(5)].map((_, index) => (
                        <FaStar
                          key={index}
                          color={
                            index < Math.round(product.productRatings)
                              ? "#ffc35b"
                              : "#e4e5e9"
                          }
                        />
                      ))}
                      <span style={{ color: "black" }}>
                        ({product.productRatings}){" "}
                      </span>

                      {/* {renderStars(4.3)}
                      <span className="ms-2 review-count">(120)</span> */}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-3">
                    {product.productQuantity > 0 ? (
                      <button
                        className="add-to-cart-btn"
                        onClick={() =>
                          navigate(`/productdetails/${product.productId}`)
                        }
                      >
                        Shop Now
                      </button>
                    ) : (
                      <button className="add-to-cart-btn" disabled>
                        Out of Stock
                      </button>
                    )}
                    <button
                      className="wishlist-btn"
                      onClick={() =>
                        isInWishlist
                          ? removeWishlistItem(product.productId)
                          : handleAddToWishlist(product.productId)
                      }
                    >
                      {isInWishlist ? (
                        <AiFillHeart className="heart-icon filled" />
                      ) : (
                        <AiOutlineHeart className="heart-icon" />
                      )}
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </SwiperSlide>
          );
        })}
        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
      </Swiper>
    </div>
  );
}

export default TopSellerExcellence;
